const getVal = (val) => {
    return val ? val : ''; // eslint-disable-line
};

export default getVal;
